import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Chip: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m630 630h-480v-480h405c41.35 0 75 33.64 75 75zm-450-30h420v-375c0-24.81-20.19-45-45-45h-375z' />
    <path d='m510 510h-240v-240h185c30.33 0 55 24.67 55 55zm-210-30h180v-155c0-13.79-11.21-25-25-25h-155zm449.84-180h-89.84v-30h59.84c16.57 0 30 13.43 30 30zm-479.84-270v89.84h30v-59.84c0-16.57-13.43-30-30-30zm210 0v89.84h30v-59.84c0-16.57-13.43-30-30-30zm0 719.84v-89.84h30v59.84c0 16.57-13.43 30-30 30zm-210 0v-89.84h30v59.84c0 16.57-13.43 30-30 30zm479.84-239.84h-89.84v-30h59.84c16.57 0 30 13.43 30 30zm-719.68-210h89.84v-30h-59.84c-16.57 0-30 13.43-30 30zm0 210h89.84v-30h-59.84c-16.57 0-30 13.43-30 30z' />
  </IconBase>
));

Chip.displayName = 'Chip';

export default Chip;
